module.exports = __webpack_public_path__ + "static/img/pd.20986b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/pd.png
// module id = 9dXQ
// module chunks = 0